import api from './index';

const postUser = (data) => api.post('/addUser', data);

const getUser = () => api.get('/getUser');

const deleteUser = (data) => api.post('/deleteUser', data);

const editUser = (data) => api.post('/editUser', data);

const editPermission = (data) => api.post('/editUserPermission', data);

const postOffice = (data) => api.post('/addOffice', data);

const deleteOffice = (data) => api.post('/deleteOffice', data);

const getOffice = () => api.get('/getOffice');

const editOffice = (data) => api.post('/editOffice', data);

const emailresend = (data) => api.post('/emailresend', data);

const emailconfirmation = (token) => api.get('/emailconfirmation', {
  params: {
    ...Object.fromEntries(Object.entries({
      token,
    }).filter((kv) => !!kv[1])),
  },
});

export {
  postUser, getUser, deleteUser, editUser, editPermission, emailconfirmation,
  postOffice, getOffice, editOffice, deleteOffice, emailresend,
};
